// extracted by mini-css-extract-plugin
export default {"Wrapper":"AppLayout_Wrapper__wLssH","App":"AppLayout_App__STxbn","Footer":"AppLayout_Footer__4pSdu"};